import axios from '@/plugins/axios';

window.openCartSaveModal = (config) => {
    if (typeof window.openSaveModal !== 'function' || !config) {
        return;
    }

    window.openSaveModal(
        {
            prefillEmail: config.email || '',
            woodSamplesUrl: window.saveModalWoodSamplesUrl || null,
            appointmentUrl: window.saveModalAppointmentUrl || null,
            type: 'save_modal',
        },
        async (form) => {
            try {
                const {data} = await axios.post(config.url, {
                    email: form.email,
                    parent_configuration_id: config.parent_configuration_id,
                    created_type: 'save_cart',
                    product_id: config.configurable_product_id,
                    special_wish: form.question,
                    terms_and_conditions: form.termsAndConditions,
                    price: config.product_price,
                    recaptcha_score: form.recaptchaScore,
                });

                if (data.status !== 'ok') {
                    console.error('Error saving cart configuration');
                    return '';
                }

                pushDataLayersEvent(data.hash, config, form.email, data.id);
                pushAfterSaveDatalayer(
                    data.after_save_datalayer_event,
                    data.customer_configuration_count,
                    config,
                    form.email,
                    data.id,
                );

                localStorage.setItem('last_configuration', JSON.stringify({
                    identifier: data.hash,
                    createdAt: (new Date()).getTime(),
                }));

                document.dispatchEvent(new CustomEvent('cartConfigurationSaved', {
                    detail: {parentConfigurationId: config.parent_configuration_id},
                }));

                return {url: data.url};
            } catch (e) {
                console.error(e);
                return '';
            }
        },
    );
};

const pushDataLayersEvent = (configurationHash, config, email, configurationId) => {
    if (typeof document === 'undefined') {
        return;
    }
    document.dispatchEvent(new CustomEvent('productSaveModalSentEvent', {
        detail: {
            product_id: config.configurable_product_id,
            product_type: config.product_type,
            product_price: config.product_price,
            parent_configuration_id: config.parent_configuration_id,
            configuration: configurationHash,
            email,
            configuration_id: configurationId,
        },
    }));
};

const pushAfterSaveDatalayer = (datalayerEvent, customerConfigurationCount, config, email, configurationId) => {
    if (typeof document === 'undefined') {
        return;
    }
    document.dispatchEvent(new CustomEvent('productConfigurationAfterSave', {
        detail: {
            event: datalayerEvent,
            product_type: config.product_type,
            product_price: config.product_price,
            configuration_count: customerConfigurationCount,
            email,
            configuration_id: configurationId,
        },
    }));
};
